import cpp from './svgs/cpp.svg';
import python from './svgs/python.svg';
import java from './svgs/java.svg';
import css from './svgs/css.svg';
import html from './svgs/html.svg';
import javascript from './svgs/javascript.svg';
import typescript from './svgs/typescript.svg';
import dart from './svgs/dart.svg';
import kotlin from './svgs/kotlin.svg';
import react from './svgs/react.svg';
import vue from './svgs/vue.svg';
import django from './svgs/django.svg';
import qt from './svgs/qt.svg';
import spring from './svgs/spring.svg';
import flutter from './svgs/flutter.svg';
import pytorch from './svgs/pytorch.svg';
import mysql from './svgs/mysql.svg';
import postgresql from './svgs/postgresql.svg';
import sqlite from './svgs/sqlite.svg';
import redis from './svgs/redis.svg';
import azure from './svgs/azure.svg';
import git from './svgs/git.svg';
import docker from './svgs/docker.svg';
import kubernetes from './svgs/kubernetes.svg';

const skillsData = {
  Languages: [
    { name: 'Python', icon: python },
    { name: 'Java', icon: java },
    { name: 'C++', icon: cpp },
    { name: 'JavaScript', icon: javascript },
    { name: 'TypeScript', icon: typescript },
    { name: 'Kotlin', icon: kotlin },
    { name: 'Dart', icon: dart },
    { name: 'HTML', icon: html },
    { name: 'CSS', icon: css },
  ],
  Frameworks: [
    { name: 'React.js', icon: react },
    { name: 'Django', icon: django },
    { name: 'Spring Boot', icon: spring },
    { name: 'Vue.js', icon: vue },
    { name: 'Flutter', icon: flutter },
    { name: 'Qt', icon: qt },
    { name: 'PyTorch', icon: pytorch },
  ],
  Databases: [
    { name: 'PostgreSQL', icon: postgresql },
    { name: 'MySQL', icon: mysql },
    { name: 'Redis', icon: redis },
    { name: 'SQLite', icon: sqlite },
  ],
  'Tools & Cloud': [
    { name: 'Git', icon: git },
    { name: 'Docker', icon: docker },
    { name: 'Kubernetes', icon: kubernetes },
    { name: 'Azure', icon: azure },
  ],
};

export default skillsData;
